import React from "react"

/**
 * Inserts `height` number of line breaks in Outlook.
 */

export function OutlookVerticalSpacer({ height = 1 }) {
  const opener = "<!--[if mso]>"
  const spaces = "<br />".repeat(height)
  const closer = "<![endif]-->"

  return <div dangerouslySetInnerHTML={{ __html: opener + spaces + closer }} />
}
